export enum ConsentType {
	HIPAA_WAIVER = 'HIPAA_WAIVER',
	TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
}

export interface ICurrentPolicy {
	getCurrentPolicy: {
		nodes: ICurrentPolicyNode[];
	};
}

export interface ICurrentPolicyNode {
	contentSummary: string;
	version: number;
}
